import * as types from "../types/single-client";
import { call, put, takeEvery, all } from "redux-saga/effects";
import {
  addNewSingleCompanySale,
  retrieveClientDetails,
  retrieveClientNotes,
  retrieveClientRoles,
  retrieveClientSales,
  updateSingleClientData,
  deleteSingleClient,
  deleteSingleClientSale,
  updateSingleClientSale,
  addSingleClientNote,
  deleteSingleClientNote,
} from "../../networking/single-client/networking";

function* fetchSingleClientDetails(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveClientDetails, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_SINGLE_CLIENT_DETAILS,
          details: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente kundedetaljer.");
      }
    } else {
      throw new Error("Kunne ikke hente kundedetaljer.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SINGLE_CLIENT_DETAILS, message: e.error });
  }
}

function* fetchSingleClientRoles(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveClientRoles, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_SINGLE_CLIENT_ROLES,
          roles: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente roller.");
      }
    } else {
      throw new Error("Kunne ikke hente roller.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SINGLE_CLIENT_ROLES, message: e });
  }
}

function* fetchSingleClientSales(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveClientSales, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_SINGLE_CLIENT_SALES,
          sales: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente salg.");
      }
    } else {
      throw new Error("Kunne ikke hente salg.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SINGLE_CLIENT_SALES, message: e });
  }
}

function* fetchSingleClientNotes(action) {
  try {
    if (action.payload) {
      const response = yield call(retrieveClientNotes, action.payload);
      if (response.error === null) {
        yield put({
          type: types.SET_SINGLE_CLIENT_NOTES,
          notes: response.payload,
        });
      } else {
        throw new Error("Kunne ikke hente notater.");
      }
    } else {
      throw new Error("Kunne ikke hente notater.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_SINGLE_CLIENT_NOTES, message: e });
  }
}

function* addSingleClientSale(action) {
  try {
    if (action.payload) {
      var response = yield call(addNewSingleCompanySale, action.payload);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_SINGLE_CLIENT_SALE });
        yield put({
          type: types.CHANGE_SINGLE_CLIENT_MODAL,
          modal: { saleModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til ny kunde.");
      }
    } else {
      throw new Error("Kunne ikke legge til salg.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_SINGLE_CLIENT_SALE, message: e });
  }
}

function* performUpdateSingleClientData(action) {
  try {
    if (action.details) {
      var response = yield call(updateSingleClientData, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_SINGLE_CLIENT_DATA });
        yield put({
          type: types.CHANGE_SINGLE_CLIENT_MODAL,
          modal: { editModal: false },
        });
      } else {
        throw new Error("Kunne ikke slette kunde.");
      }
    } else {
      throw new Error("Kunne ikke endre kunde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_SINGLE_CLIENT_DATA, message: e });
    yield put({
      type: types.CHANGE_SINGLE_CLIENT_MODAL,
      modal: { editModal: false },
    });
  }
}

function* performDeleteSingleClientData(action) {
  try {
    if (action.details) {
      var response = yield call(deleteSingleClient, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_REMOVE_SINGLE_CLIENT_DATA });
        yield put({
          type: types.CHANGE_SINGLE_CLIENT_MODAL,
          modal: { removeModal: false },
        });
      } else {
        throw new Error("Kunne ikke slette kunde.");
      }
    } else {
      throw new Error("Kunne ikke slette kunde.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_REMOVE_SINGLE_CLIENT_DATA, message: e });
    yield put({
      type: types.CHANGE_SINGLE_CLIENT_MODAL,
      modal: { removeModal: false },
    });
  }
}

function* performDeleteSingleClientDataSale(action) {
  try {
    if (action.details) {
      var response = yield call(deleteSingleClientSale, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_REMOVE_SINGLE_CLIENT_SALE });
        yield put({
          type: types.CHANGE_SINGLE_CLIENT_MODAL,
          modal: { removeSaleModal: false },
        });
      } else {
        throw new Error("Kunne ikke slette salg.");
      }
    } else {
      throw new Error("Kunne ikke slette salg.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_REMOVE_SINGLE_CLIENT_SALE, message: e });
    yield put({
      type: types.CHANGE_SINGLE_CLIENT_MODAL,
      modal: { removeSaleModal: false },
    });
  }
}

function* performUpdateSingleClientDataSale(action) {
  try {
    if (action.details) {
      var response;
      response = yield call(updateSingleClientSale, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_SINGLE_CLIENT_SALE });
        yield put({
          type: types.CHANGE_SINGLE_CLIENT_MODAL,
          modal: { editSaleModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere salg.");
      }
    } else {
      throw new Error("Kunne ikke oppdatere salg.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_SINGLE_CLIENT_SALE, message: e });
    yield put({
      type: types.CHANGE_SINGLE_CLIENT_MODAL,
      modal: { editSaleModal: false },
    });
  }
}

function* performAddSingleClientDataNote(action) {
  try {
    if (action.details) {
      var response = yield call(addSingleClientNote, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_SINGLE_CLIENT_NOTE });
      } else {
        throw new Error("Kunne ikke legge til ny kunde.");
      }
    } else {
      throw new Error("Kunne ikke legge til notat.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_SINGLE_CLIENT_NOTE, message: e });
  }
}

function* performDeleteSingleClientDataNote(action) {
  try {
    if (action.details) {
      var response = yield call(deleteSingleClientNote, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_REMOVE_SINGLE_CLIENT_NOTE });
      } else {
        throw new Error("Kunne ikke slette notat.");
      }
    } else {
      throw new Error("Kunne ikke slette notat.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_REMOVE_SINGLE_CLIENT_NOTE });
  }
}

function* singleClientSaga() {
  yield all([
    takeEvery(types.REQUEST_SINGLE_CLIENT_DETAILS, fetchSingleClientDetails),
    takeEvery(types.REQUEST_SINGLE_CLIENT_ROLES, fetchSingleClientRoles),
    takeEvery(types.REQUEST_SINGLE_CLIENT_SALES, fetchSingleClientSales),
    takeEvery(types.REQUEST_SINGLE_CLIENT_NOTES, fetchSingleClientNotes),
    takeEvery(types.REQUEST_ADD_SINGLE_CLIENT_SALE, addSingleClientSale),
    takeEvery(
      types.REQUEST_UPDATE_SINGLE_CLIENT_DATA,
      performUpdateSingleClientData
    ),
    takeEvery(
      types.REQUEST_REMOVE_SINGLE_CLIENT_DATA,
      performDeleteSingleClientData
    ),
    takeEvery(
      types.REQUEST_REMOVE_SINGLE_CLIENT_SALE,
      performDeleteSingleClientDataSale
    ),
    takeEvery(
      types.REQUEST_UPDATE_SINGLE_CLIENT_SALE,
      performUpdateSingleClientDataSale
    ),
    takeEvery(
      types.REQUEST_ADD_SINGLE_CLIENT_NOTE,
      performAddSingleClientDataNote
    ),
    takeEvery(
      types.REQUEST_REMOVE_SINGLE_CLIENT_NOTE,
      performDeleteSingleClientDataNote
    ),
  ]);
}

export default singleClientSaga;
